<template>
    <div id="contenedor-main-listado-Oficios-Autorizacion">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
            :soloLectura="soloLectura"
            :listadoOficiosAutorizacion="listadoOficiosAutorizacion">
            </desktop>
        </template>
        <template
            v-else>
            <desktop
            :soloLectura="soloLectura"
            :listadoOficiosAutorizacion="listadoOficiosAutorizacion">
            </desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoOficiosAutorizacion',
  props: {
    listadoOficiosAutorizacion: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {
      soloLectura: false,
    };
  },
};
</script>

<style lang="scss">

</style>
